<template>
    <hts-drawer
        ref="drawer"
        v-model="visible"
        :submit="submit"
        :title="page === 0 ? $t('labels.quoteRequestAdd') : $t('labels.quoteAdd')"
        :rules="dataRule"
        :size="90"
        @close="close">
        <div
            v-if="visible"
            :style="{ minWidth: minWidthScroll }">
            <div v-show="page === 0">
                <hts-card :title="$t('labels.customer')">
                    <div class="grid gap-x-2 grid-cols-4">
                        <hts-select-cooperator
                            v-model="dataAddQuotRequest.customer"
                            v-model:name="dataAddQuotRequest.customerName"
                            :label="$t('labels.customer')"
                            type-cooperator="CUSTOMER"
                            :creatable="true"
                            required
                            prop="customer"
                            name-select="customer"
                            @change="selectCustomer" />
                        <hts-select-cooperator-contact
                            v-model="dataAddQuotRequest.contact"
                            v-model:name="dataAddQuotRequest.contactName"
                            :disabled="!dataAddQuotRequest.customer"
                            :cooperator-id="dataAddQuotRequest.customer"
                            :label="$t('labels.contact')"
                            :creatable="true"
                            required
                            prop="contact"
                            name-select="contact"
                            :param-prepare="dataAddQuotRequest.customer"
                            @change="selectContact" />
                        <hts-form-input
                            v-model="dataContact.email"
                            :label="$t('labels.email')"
                            disabled />
                        <hts-form-input
                            v-model="dataContact.phone"
                            :label="$t('labels.phone')"
                            disabled />
                    </div>
                </hts-card>
                <hts-card :title="$t('labels.shippingInformation')">
                    <div class="grid gap-x-2 grid-cols-2">
                        <hts-select-cooperator-business-opportunity
                            v-model="dataAddQuotRequest.businessOpportunity"
                            v-model:name="dataAddQuotRequest.businessOpportunityName"
                            :label="$t('labels.businessOpportunity')"
                            :creatable="true"
                            :disabled="!dataAddQuotRequest.customer"
                            :cooperator-id="dataAddQuotRequest.customer"
                            required
                            prop="businessOpportunity"
                            name-select="businessOpportunity"
                            key-label="nameCustom1"
                            key-sub-label="nameCustom2"
                            :param-prepare="dataAddQuotRequest.customer"
                            @change="selectCooperatorBusinessOpportunity" />
                        <hts-select-commodity-opportunity
                            v-model="dataAddQuotRequest.commodity"
                            v-model:name="dataAddQuotRequest.commodityName"
                            :label="$t('labels.commodity')"
                            :creatable="true"
                            :disabled="!dataAddQuotRequest.customer || !dataAddQuotRequest.businessOpportunity"
                            :cooperator-id="dataAddQuotRequest.customer"
                            :opportunity-id="dataAddQuotRequest.businessOpportunity"
                            required
                            prop="commodityBusinessOpportunity"
                            name-select="commodityBusinessOpportunity"
                            :param-prepare="dataAddQuotRequest.businessOpportunity" />
                    </div>

                    <hts-form-input
                        v-model="dataAddQuotRequest.workflowName"
                        :label="$t('labels.workflow')"
                        disabled
                        required />

                    <ul
                        v-if="dataAddQuotRequest.positions && dataAddQuotRequest.positions.length"
                        class="steps steps-vertical w-full">
                        <li
                            v-for="(item, index) in dataAddQuotRequest.positions"
                            :key="index"
                            data-content=" "
                            class="pl-10 step w-full">
                            <div class="flex items-center justify-center w-full">
                                <span class="w-52 flex justify-start">
                                    {{ item.nodeTypeName }}
                                </span>
                                <div class="flex items-center w-full gap-5">
                                    <hts-form-input
                                        v-model="item.fullNameNode"
                                        class="w-full"
                                        readonly />

                                    <hts-form-button
                                        icon-name="hi-pencil-square-icon"
                                        size="small"
                                        class="w-96"
                                        color="info"
                                        @click="() => openWorkflowPosition(item)">
                                        {{ $t('labels.editCompletionTime') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <hts-form-button
                        v-if="dataAddQuotRequest.positions && dataAddQuotRequest.positions.length"
                        icon-name="hi-plus-circle-icon"
                        class="text-right mt-5 w-48"
                        color="info"
                        :btn-outline="false"
                        type="button"
                        @click="handleFindRoutingConnection">
                        {{ $t('labels.selectTheLeftLane') }}
                    </hts-form-button>

                    <div>
                        <div v-if="dataAddQuotRequest.transportation === 'CONTAINER'">
                            <hts-form-input
                                v-model="dataAddQuotRequest.contName"
                                :label="$t('labels.cont')"
                                disabled
                                required />
                            <span class="mt-2">
                                {{ $t('labels.requestSpecial') }}
                            </span>
                            <div class="flex">
                                <hts-form-checkbox
                                    v-if="dataAddQuotRequest.contCategory === 20"
                                    v-model="dataAddQuotRequest.mergeContainer"
                                    color="secondary"
                                    :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                                <hts-form-checkbox
                                    v-model="dataAddQuotRequest.headContainer"
                                    color="secondary"
                                    :items="[{ label: $t('labels.headContainer'), value: false }]" />
                            </div>
                        </div>
                        <div v-else-if="dataAddQuotRequest.transportation === 'NON_CONTAINER'">
                            <hts-form-input
                                v-model="dataAddQuotRequest.vehicleCategoryName"
                                :label="$t('labels.vehicleType')"
                                disabled
                                required />
                        </div>
                        <hts-form-input
                            v-model="dataAddQuotRequest.productivity"
                            :label="$t('labels.productivityByMount')"
                            type="number"
                            required
                            prop="productivity"
                            name="productivity">
                            <template #suffix>
                                <span>
                                    {{ dataAddQuotRequest.transportation ? (dataAddQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                </span>
                            </template>
                        </hts-form-input>
                        <hts-form-input
                            v-model="dataAddQuotRequest.weightCommodity"
                            :label="$t('labels.weightCommodityByKG1')"
                            type="number"
                            required
                            prop="weightCommodityByKG"
                            name="weightCommodityByKG1">
                            <template #suffix>
                                <span>
                                    {{
                                        dataAddQuotRequest.transportation ? `/${dataAddQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')}` : '-'
                                    }}
                                </span>
                            </template>
                        </hts-form-input>
                        <hts-form-textarea
                            v-model="dataAddQuotRequest.request"
                            :label="$t('labels.requestOther')" />
                    </div>
                </hts-card>
                <workflow-position
                    ref="workflowPosition"
                    @update="updatePosition" />
            </div>
            <div v-if="page === 1">
                <add-quote
                    ref="addQuote"
                    v-model:request-price="dataAddQuotRequest.requestPrice"
                    :show-modal-alert="true"
                    :quote-data="dataQuotePrice"
                    @requestPrice="requestPrice" />
            </div>
        </div>
        <template #footer="submitting">
            <template v-if="page === 0">
                <hts-form-button
                    icon-name="hi-check-icon"
                    color="primary"
                    type="submit"
                    :loading="loadingCreateQuoteRequest"
                    @click="typeSubmit = 0">
                    {{ $t('labels.save') }}
                </hts-form-button>
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.quote_management)"
                    icon-name="hi-arrow-long-right-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="loadingViewQuote"
                    @click="typeSubmit = 1">
                    {{ $t('labels.viewPrice') }}
                </hts-form-button>
            </template>
            <template v-else>
                <hts-form-button
                    icon-name="hi-arrow-long-left-icon"
                    color="primary"
                    type="submit"
                    @click="
                        () => {
                            typeSubmit = -1
                            !(addQuote && addQuote.step === 0) ? addQuote && addQuote.previousStep() : (page = 0)
                        }
                    ">
                    {{ $t('labels.back') }}
                </hts-form-button>
                <div
                    v-if="addQuote && addQuote.step === 2"
                    class="flex">
                    <hts-form-button
                        icon-name="hi-arrow-long-right-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :disabled="loadingCreateByQuoteRequest || addQuote.checkMarkupPricingSelection({ checkPermission: true })"
                        :loading="loadingCreateQuoteByQuoteRequestIsSenIsMail"
                        @click="typeSubmit = 3">
                        {{ $t('labels.createAndSend') }}
                    </hts-form-button>
                    <hts-form-button
                        class="ml-5"
                        icon-name="hi-arrow-long-right-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :disabled="loadingCreateQuoteByQuoteRequestIsSenIsMail"
                        :loading="loadingCreateByQuoteRequest"
                        @click="typeSubmit = 2">
                        {{ $t('labels.create') }}
                    </hts-form-button>
                </div>
                <hts-form-button
                    v-if="addQuote && addQuote.step < 2"
                    icon-name="hi-arrow-long-right-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    @click="
                        () => {
                            typeSubmit = -1
                            addQuote && addQuote.nextStep()
                        }
                    ">
                    {{ $t('labels.next') }}
                </hts-form-button>
            </template>
        </template>

        <routing-connection
            ref="routingConnection"
            @update="updateRoutingConnections" />

        <hts-modal
            :show="showPopupRequestPrice"
            :title="$t('labels.requestPrice')"
            type="confirm"
            :content="$t('labels.confirmRequestPrice2')"
            :loading="loadingCreateAndRequestPrice"
            @hide="showPopupRequestPrice = false"
            @confirm="confirmRequestPrice" />
    </hts-drawer>
</template>

<script setup lang="ts">
import AddQuote from '../../-components/add.vue'
import type { IQuoteRequest } from './ignore/imports/form'
import RoutingConnection from './routing-connection.vue'
import WorkflowPosition from './workflow-position.vue'
import { $api } from '#imports'
import { checkPermission } from '@/utils/permission-check'
import screen from '~/components/utils/screen'
import layoutPermissions from '~/data/permissions/layout-permissions'
import type { IWorkflowPosition } from '~/pages/admincp/workflow/-imports/form'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})
const router = useRouter()

const { $disableReactive } = useNuxtApp()

const visible = ref(false)
const routingConnection = ref()
const routingConnectionsData = ref<{ [key: string]: any }[][]>([])

const page = ref(0)

const typeSubmit = ref(0)
const submit = async () => {
  switch (
    typeSubmit.value // 0 create quote request 1 get price 2 create quote 3 create quote and send mail
  ) {
  case 0:
    return await createQuoteRequest()
  case 1:
    return await getQuotePriceData()
  case 2:
    return await handleQuoteByQuoteRequest()
  case 3:
    return await createQuoteByQuoteRequestIsSenIsMail({ sendEmail: true })
  default:
  }
}

const goViewQuote = () => {
  typeSubmit.value = 2
}

const addQuote = ref()
const loadingCreateQuoteRequest = ref(false)
const showPopupRequestPrice = ref(false)
const loadingCreateAndRequestPrice = ref(false)

const createQuoteRequest = async () => {
  loadingCreateQuoteRequest.value = true
  const api = $urlPartner.quote.quoteRequest.create
  const data: any = await $api(api, { body: dataAddQuotRequest.value })
  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      process.client && $toast().success($t('labels.createQuoteRequestSuccess'))
      close()
      resetField()
      emits('refreshTables')
      emits('newQuoteRequest', resData.meta)
    }
  }
  loadingCreateQuoteRequest.value = false
}
const close = () => {
  visible.value = false
}

const emits = defineEmits(['refreshTables', 'newQuoteRequest'])

const workflowPosition = ref()
const openWorkflowPosition = (position: IWorkflowPosition) => {
  if (!position) {
    $toast().error('Địa điểm không tồn tại')
  }
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), $disableReactive(dataAddQuotRequest.value), false)
  }
}

const open = () => {
  visible.value = true
}

const resetField = () => {
  dataContact.value = {}
  dataAddQuotRequest.value = {
    customer: '',
    customerName: '',
    commodity: '',
    commodityName: '',
    contact: '',
    businessOpportunity: '',
    workflow: '',
    workflowData: [],
    productivity: null,
    weightCommodity: null,
    tasks: [
      {
        code: '',
        value: null
      }
    ],
    request: '',
    requestSpecial: '',
    contactName: '',
    mergeContainer: false,
    headContainer: false,
    transportation: '',
    businessOpportunityName: '',
    contCategory: null,
    vehicleCategory: '',
    requestPrice: false,
    status: -1,
    routingConnections: undefined,
    connectingPositions: undefined
  }
  page.value = 0
}

defineExpose({
  open
})
const store = $store()

const dataAddQuotRequest = ref<IQuoteRequest>({
  customer: '',
  customerName: '',
  commodity: '',
  commodityName: '',
  contact: '',
  positions: [],
  businessOpportunity: '',
  businessOpportunityName: '',
  workflow: '',
  workflowName: '',
  workflowData: [],
  productivity: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: null
    }
  ],
  request: '',
  requestSpecial: '',
  transportation: '',
  contactName: '',
  mergeContainer: false,
  headContainer: false,
  contCategory: null,
  contName: '',
  vehicleCategoryName: '',
  vehicleCategory: '',
  requestPrice: false,
  status: -1,
  routingConnections: undefined,
  connectingPositions: undefined
})

const resetFields = () => {
  resetField()
  dataContact.value = { email: '', phone: '' }
  routingConnectionsData.value = []
}

const props = defineProps({
  initialValues: {
    type: Object,
    default: () => {}
  }
})

const dataContact = ref<{ [key: string]: any }>({})
const selectContact = (item: { [key: string]: any }) => {
  if (!Array.isArray(item) || !item.length) {
    dataContact.value.email = ''
    dataContact.value.phone = ''
    return
  }

  dataContact.value = item[0]
  dataAddQuotRequest.value.contactName = item[0]?.fullName
}

const selectCustomer = (item: { [key: string]: any }) => {
  if (!Array.isArray(item) || !item.length) {
    resetFields()
    return
  }

  resetFields()
  dataAddQuotRequest.value.customer = item[0]._id
  dataAddQuotRequest.value.customerName = item[0].name
}

const dataCooperatorBusinessOpportunity = ref<{ [key: string]: any }>({})
const selectCooperatorBusinessOpportunity = async (item: { [key: string]: any }) => {
  dataCooperatorBusinessOpportunity.value = Array.isArray(item) && item.length && item[0]
  dataAddQuotRequest.value.commodity = ''
  dataAddQuotRequest.value.commodityName = ''
  dataAddQuotRequest.value.routingConnections = undefined
  dataAddQuotRequest.value.connectingPositions = undefined
  routingConnectionsData.value = []
  await setFormData()
}

const setFormData = async () => {
  dataAddQuotRequest.value.productivity = dataCooperatorBusinessOpportunity.value.productivity || null
  dataAddQuotRequest.value.weightCommodity = dataCooperatorBusinessOpportunity.value.weightCommodity || null
  dataAddQuotRequest.value.transportation = dataCooperatorBusinessOpportunity.value.transportation || ''
  if (dataAddQuotRequest.value.transportation && dataAddQuotRequest.value.transportation === 'CONTAINER') {
    dataAddQuotRequest.value.contName = listLabelCont[dataCooperatorBusinessOpportunity.value.contCategory] ?? ''
  } else if (dataAddQuotRequest.value.transportation && dataAddQuotRequest.value.transportation === 'NON_CONTAINER') {
    dataAddQuotRequest.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryDetail?.name ?? ''
  }
  dataAddQuotRequest.value.workflow = dataCooperatorBusinessOpportunity.value.workflow
  dataAddQuotRequest.value.workflowName = dataCooperatorBusinessOpportunity.value.workflowName
  dataAddQuotRequest.value.contCategory = dataCooperatorBusinessOpportunity.value.contCategory
  dataAddQuotRequest.value.vehicleCategory = dataCooperatorBusinessOpportunity.value.vehicleCategory
  dataAddQuotRequest.value.headContainer = false
  dataAddQuotRequest.value.mergeContainer = false
  dataAddQuotRequest.value.positions = dataCooperatorBusinessOpportunity.value.positions || []
  await setDataPosition()
}

const setDataPosition = async () => {
  try {
    const api = $urlPartner.quote.quoteRequest.viewTimeComplete
    if (dataAddQuotRequest.value.businessOpportunity) {
      const data: any = await $api(api, { uriParams: { IDBUSINESSOPPORTUNITY: dataAddQuotRequest.value.businessOpportunity } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataAddQuotRequest.value.positions = resData.data
      }
    }
  } catch (e) {}
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)
const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const dataRule = computed(() => {
  const result: { [key: string]: any } = {}
  if (dataAddQuotRequest.value.transportation === 'CONTAINER' && dataAddQuotRequest.value.contCategory) {
    if (configCont.value && configCont.value[dataAddQuotRequest.value.contCategory] && configCont.value[dataAddQuotRequest.value.contCategory].weightCargo) {
      result.weightCommodityByKG = `required|validationCustom:
      ${
        dataAddQuotRequest.value.weightCommodity &&
        dataAddQuotRequest.value.weightCommodity <= configCont.value[dataAddQuotRequest.value.contCategory].weightCargo
      }--
      ${$t('labels.checkWeightContainer')} - ${configCont.value[dataAddQuotRequest.value.contCategory].weightCargo}`
    }
  } else if (dataAddQuotRequest.value.transportation === 'NON_CONTAINER' && dataAddQuotRequest.value.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === dataAddQuotRequest.value.vehicleCategory
    })
    if (findVehicleCategory) {
      const min = Number(findVehicleCategory.from || 0)
      const max = Number(findVehicleCategory.to || 999999999999999)
      result.weightCommodityByKG = `required|validationCustom:
      ${dataAddQuotRequest.value.weightCommodity && min <= dataAddQuotRequest.value.weightCommodity && dataAddQuotRequest.value.weightCommodity < max}--
      ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
    }
  }

  if (addQuote.value && addQuote.value.step === 2 && addQuote.value.dataCreateQuote.effectiveFromDate) {
    const quoteRules: { [key: string]: any } = { ...ruleCreateQuote }

    const date = addQuote.value.dataCreateQuote.effectiveFromDate ? new Date(addQuote.value.dataCreateQuote.effectiveFromDate) : ''
    if (date && addQuote.value.dataCreateQuote.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      result.effectiveToDate = quoteRules.effectiveToDate + `|min_date:${date.toISOString().split('T')[0]}`
    }
  }
  return result
})

const updatePosition = (data: { [key: string]: any }) => {
  if (data && typeof data === 'object' && dataAddQuotRequest.value.positions) {
    const findIndexPosition = dataAddQuotRequest.value.positions.findIndex((item: { [key: string]: any }) => {
      return item.index === data.index
    })
    if (findIndexPosition !== -1 && dataAddQuotRequest.value.positions) {
      dataAddQuotRequest.value.positions[findIndexPosition] = data
    }
  }
}

const dataQuotePrice = ref({} as { [key: string]: any })
const loadingViewQuote = ref(false)
const getQuotePriceData = async () => {
  try {
    loadingViewQuote.value = true
    const api = $urlPartner.quote.getDraftQuotePrice
    if (dataAddQuotRequest.value.businessOpportunity) {
      const data: any = await $api(api, { body: dataAddQuotRequest.value })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataQuotePrice.value = resData.data
        page.value = 1
      }
      loadingViewQuote.value = false
    }
  } catch (e) {
    loadingViewQuote.value = false
  }
}

const loadingCreateByQuoteRequest = ref(false)
const loadingCreateQuoteByQuoteRequestIsSenIsMail = ref(false)
const createQuoteByQuoteRequestIsSenIsMail = async (options: { [key: string]: any } = {}) => {
  try {
    loadingCreateQuoteByQuoteRequestIsSenIsMail.value = true
    await createQuoteByQuoteRequest(options)
    loadingCreateQuoteByQuoteRequestIsSenIsMail.value = false
  } catch (e: any) {
    loadingCreateQuoteByQuoteRequestIsSenIsMail.value = false
  }
}
const handleQuoteByQuoteRequest = async (options: { [key: string]: any } = {}) => {
  try {
    loadingCreateByQuoteRequest.value = true
    await createQuoteByQuoteRequest(options)
    loadingCreateByQuoteRequest.value = false
  } catch (e: any) {
    loadingCreateByQuoteRequest.value = false
  }
}
const createQuoteByQuoteRequest = async (options: { [key: string]: any } = {}) => {
  const api = $urlPartner.quote.createQuoteByQuoteRequest

  const dataRequestQuote = {
    ...$lodash.pick(
      addQuote.value.dataCreateQuote,
      'quoteRequestId',
      'informationEditorPricingSelling',
      'workflow',
      'contact',
      'exceptCompensationCost',
      'compensationCost',
      'groupEmail',
      'abstemious',
      'customerService',
      'transportation',
      'positions',
      'customer',
      'quoteTempSaveId',
      'effectiveFromDate',
      'effectiveToDate',
      'comfirmRouteGGMap'
    ),
    priceOfflineFeeIds: $lodash.map(addQuote.value.dataCreateQuote?.priceOfflineFee, '_id'),
    chargeIds: $lodash.map(addQuote.value.dataPositionsPricing, '_id')
  }

  dataRequestQuote.comfirmRouteGGMap = !!dataQuotePrice.value?.comfirmRouteGGMap

  const data: any = await $api(api, {
    body: {
      quoteRequest: dataAddQuotRequest.value,
      quote: dataRequestQuote,
      sendEmail: !!options.sendEmail
    }
  })
  const resData = data?.data?.value

  if (resData && resData.success) {
    close()
    page.value = 0
    resetField()
    process.client && $toast().success($t('labels.createQuoteSuccess'))
    // emits('refreshTables')
    nextTick(() => {
      router.push({ name: 'c-id-quote-management' })
    })
  }
}

const ruleCreateQuote = {
  effectiveFromDate: 'required|min_date:1970-01-01',
  effectiveToDate: 'min_date:1970-01-01'
}

const drawer = ref()

const handleFindRoutingConnection = () => {
  if (routingConnection?.value) {
    routingConnection.value.open(
      dataAddQuotRequest.value.positions || [],
      dataAddQuotRequest.value.routingConnections,
      dataAddQuotRequest.value.connectingPositions || []
    )
  }
}

const updateRoutingConnections = (data: { [key: string]: any }) => {
  dataAddQuotRequest.value.routingConnections = data.routingConnections
  dataAddQuotRequest.value.connectingPositions = data.connectingPositions
  routingConnectionsData.value = data.routingConnectionsData
}

const requestPrice = () => {
  showPopupRequestPrice.value = true
}

const confirmRequestPrice = $lodash.debounce(async () => {
  loadingCreateAndRequestPrice.value = true
  const api = $urlPartner.quote.quoteRequest.createAndRequestPrice
  const data: any = await $api(api, { body: dataAddQuotRequest.value })
  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      process.client && $toast().success($t('labels.createQuoteRequestSuccess'))
      close()
      resetField()
      emits('refreshTables')
      emits('newQuoteRequest', resData.meta)
      showPopupRequestPrice.value = false
    }
  }
  loadingCreateAndRequestPrice.value = false
})
</script>
